<template>
  <div class="w-full">
    <!-- PRELOAD -->

    <!-- v-else -->
    <img
      src="@/assets/images/caspian/hero.jpg"
      class="fixed w-px h-px opacity-0 -z-10"
      alt=""
      ref="heroPic"
      @load="lhero = true"
    />
    <img
      class="fixed w-px h-px opacity-0 -z-10"
      v-for="(col, index) in spectrum"
      :key="index"
      :src="col.car"
      alt=""
    />
    <!-- PRELOAD -->
    <div
      v-if="!lhero"
      class="fixed top-0 left-0 z-50 flex items-center justify-center w-full h-screen"
    >
      <div
        class="bg-[#1B1B1B] absolute load1 top-0 left-0 w-full h-screen z-0"
      ></div>
      <div
        class="bg-[#1B1B1B] absolute load2 top-0 left-0 w-full h-screen z-0"
      ></div>
      <div class="img1">
        <img
          src="@/assets/images/miniLogo.png"
          class="z-[1] zoom img1"
          alt="Logo"
        />
      </div>
    </div>
    <div class="w-full">
      <section
        class="relative w-full heroBG md:min-h-0 min-h-screen md:max-h-none max-h-screen"
      >
        <img
          src="@/assets/images/caspian/hero.jpg"
          class="w-full md:block hidden"
          alt=""
        />
        <div class="absolute top-0 right-0 left-0">
          <div
            class="min-h-screen max-h-none md:w-[90%] w-[95%] max-w-xl mx-auto h-full flex flex-col items-start justify-between md:pt-[20vh] md:pl-10 pt-[15vh] pb-[10vh]"
          >
            <!-- <div class="hidden w-full md:block"></div> -->
            <div class="w-full">
              <h1 class="font-belgiano md:text-[80px] text-[36px]">
                Caspian<span class="text-green">.</span>
              </h1>
              <p class="text-xs font-inter md:text-2xl">
                Starting from ₦{{ prcs.caspian }} million
              </p>
              <div class="flex items-center gap-6 mt-3">
                <p class="text-xs font-inter md:text-lg">
                  {{ downpaymentPercentage }}% down payment
                </p>
                <div class="w-px h-4 bg-realBlack"></div>
                <p class="text-xs font-inter md:text-lg">Spread over 5 years</p>
              </div>
              <router-link :to="{ name: 'order-caspian' }">
                <button
                  class="black-btn w-[clamp(9.375rem,5.869vw+7.174rem,15.625rem)] mt-7"
                >
                  Order Now
                </button>
              </router-link>
            </div>
          </div>
        </div>
        <div class="ovl absolute bottom-0 left-0 right-0 h-[12vh]"></div>
      </section>
      <section class="w-full bg-realBlack">
        <div
          class="flex flex-wrap justify-between items-center md:w-[90%] w-[95%] max-w-xl mx-auto py-20 md:gap-4 gap-y-6 md:flex-nowrap"
        >
          <div class="text-center md:w-1/4 w-[50%]">
            <p
              class="font-inter text-white text-xs uppercase tracking-[1.25px]"
            >
              Dimension
            </p>
            <p class="mt-1 text-sm font-inter text-white md:text-xl">
              L:4450 x W:1860 x H:1635
            </p>
          </div>
          <!-- <div class="w-px h-4 md:block hidden bg-white bg-opacity-40"></div> -->
          <div class="text-center md:w-1/4 w-[45%]">
            <p
              class="font-inter text-white text-xs uppercase tracking-[1.25px]"
            >
              Top Speed
            </p>
            <p class="mt-1 text-sm font-inter text-white md:text-xl">160Km/H</p>
          </div>
          <!-- <div class="w-px h-4 md:block hidden bg-white bg-opacity-40"></div> -->
          <div class="text-center md:w-1/4 w-[45%]">
            <p
              class="font-inter text-white text-xs uppercase tracking-[1.25px]"
            >
              Range
            </p>
            <p class="mt-1 text-sm font-inter text-white md:text-xl">445Km</p>
          </div>
          <!-- <div class="w-px h-4 md:block hidden bg-white bg-opacity-40"></div> -->
          <div class="text-center md:w-1/4 w-[45%]">
            <p
              class="font-inter text-white text-xs uppercase tracking-[1.25px]"
            >
              Battery
            </p>
            <p class="mt-1 text-sm font-inter text-white md:text-xl">
              48.35(KWh)
            </p>
          </div>
        </div>
      </section>
      <section class="w-full bg-realBlack text-white">
        <div class="w-full max-w-[1550px] mx-auto">
          <div class="md:w-[70%] w-full mx-auto">
            <img
              src="@/assets/images/caspian/cockpit.png"
              alt=""
              class="w-full"
            />
            <div class="w-full max-w-[1550px] mx-auto">
              <div class="md:w-full w-[95%] mx-auto">
                <div class="w-full md:pt-5 pt-3 pb-4 md:pb-8">
                  <h3
                    class="capitalize font-belgiano md:text-[26px] text-[1rem] tracking-[1.4px] w-full"
                  >
                    Drive Harmoniously
                  </h3>
                  <p class="md:text-base text-xs tracking-[1.8px] w-full mt-3">
                    Caspian's interior is clean and understated, designed to feel
                    calm and easy to use. A 14.6-inch central screen and simple
                    dual-spoke steering wheel give it a modern, tech-focused
                    look, while its AI-powered system and in-house cockpit
                    software create a more intuitive and personalized driving
                    experience.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="w-full bg-realBlack block">
        <div class="w-full overflow-x-auto">
          <img
            src="@/assets/images/caspian/trunk.jpg"
            class="md:w-full w-[200%] md:min-w-0 min-w-[200%]"
            alt=""
          />
        </div>
        <div class="w-full max-w-[1550px] mx-auto">
          <div class="md:w-[95%] w-full mx-auto">
            <div class="md:w-full w-[95%] py-20 mx-auto">
              <div class="md:w-1/2 w-full max-w-xl">
                <h3
                  class="capitalize text-white font-belgiano md:text-[26px] text-[1rem] tracking-[1.4px] w-full"
                >
                  Carry More Than Just Plans
                </h3>
                <p
                  class="md:text-base text-xs tracking-[1.8px] text-white w-full mt-3"
                >
                  Caspian keeps things clean on the outside, but opens up when
                  it counts. A spacious, well-shaped trunk makes room for real
                  life, whether it's luggage, last-minute errands, or the
                  unexpected extras that come with the journey.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="w-full bg-white">
        <div class="w-full max-w-[1550px] mx-auto">
          <div class="md:w-[95%] w-full mx-auto">
            <div class="md:w-full w-[95%] md:py-20 py-12 mx-auto">
              <div class="w-full grid grid-cols-2 gap-4">
                <div class="relative " >
                  <img
                    src="@/assets/images/caspian/tyre.jpg"
                    alt=""
                    class="w-full"
                  />
                </div>
                <div class="relative " >
                  <img
                    src="@/assets/images/caspian/back.jpg"
                    alt=""
                    class="w-full"
                  />
                </div>
                <div class="relative col-span-2">
                  <img
                    src="@/assets/images/caspian/front.jpg"
                    class="w-full"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="w-full bg-realBlack block">
        <img
          src="@/assets/images/caspian/people.png"
          alt=""
          class="w-full md:block hidden"
        />
        <img
          src="@/assets/images/caspian/people.png"
          alt=""
          class="w-full block md:hidden"
        />
        <div class="w-full max-w-[1550px] mx-auto">
          <div class="md:w-[95%] w-full mx-auto">
            <div class="md:w-full w-[95%] md:py-20 py-10 mx-auto">
              <div class="md:w-3/4 w-full max-w-xl">
                <h3
                  class="capitalize text-white font-belgiano md:text-[26px] text-[1rem] tracking-[1.4px] w-full"
                >
                  Power You Can Trust
                </h3>
                <p
                  class="md:text-base text-xs tracking-[1.8px] text-white w-full mt-3"
                >
                  The vehicle is powered by an electric motor developed by
                  Huawei Digital Energy Technology Co., delivering up to 122 kW
                  of output. It also uses a high-grade lithium iron phosphate
                  (LFP) battery, built for reliability, safety, and long-term
                  performance.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="w-full bg-realBlack block">
        <img
          src="@/assets/images/caspian/side.jpg"
          alt=""
          class="w-full hidden md:block"
        />
        <img
          src="@/assets/images/caspian/side.jpg"
          alt=""
          class="md:hidden block w-full"
        />
        <div class="w-full max-w-[1550px] mx-auto">
          <div class="md:w-[95%] w-full mx-auto">
            <div class="md:w-full w-[95%] md:py-20 py-8 mx-auto">
              <div class="md:w-3/4 w-full max-w-xl">
                <h3
                  class="capitalize text-white font-belgiano md:text-[26px] text-[1rem] tracking-[1.4px] w-full"
                >
                  Understated, Until it isn't
                </h3>
                <p
                  class="md:text-base text-xs tracking-[1.8px] text-white w-full mt-3"
                >
                  Caspian's “light and shadow” design gives it a sleek, youthful
                  look, highlighted by split butterfly-style headlights and
                  dark sporty accents. Clean side lines, a blacked-out roof,
                  and aerodynamic details enhance its style and efficiency,
                  while distinctive rear lights and a roof spoiler complete its
                  sporty finish.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="w-full bg-realBlack">
        <div class="xl:w-[90%] lg:w-[95%] mx-auto md:pt-0 pt-8">
          <div class="md:w-full w-[95%] mx-auto md:pl-8">
            <h2
              class="capitalize font-belgiano text-[1rem] md:text-[56px] text-white"
            >
              Go The Distance
            </h2>
          </div>
          <img
            src="@/assets/images/caspian/distance.png"
            alt=""
            class="w-full mt-4 md:mt-8"
          />
          <div class="md:w-full w-[95%] mx-auto md:pl-8 pb-10">
            <p
              class="md:text-base text-white text-xs tracking-[1.8px] md:mt-9 mt-4 md:w-2/3 w-full"
            >
              With a single charge, it can travel up to 445km, effortlessly
              covering long routes like Lagos to Benin, Edo State (321.1 km) and
              still having plenty of juice left to spare. Experience the freedom
              to go further, without worrying about running out of charge.
            </p>
          </div>
        </div>
      </section>
      <!-- <section class="w-[95%] max-w-[1550px] mx-auto md:pt-[120px] pt-9">
        <div class="w-full max-w-xl md:pl-8">
          <h2 class="capitalize font-belgiano text-[1rem] md:text-[56px]">
            View Our Spectrum
          </h2>
        </div>
      </section>
      <section class="relative w-full overflow-hidden" ref="swipeArea">
        <div
          class="absolute top-0 left-0 right-0 bottom-0 flex items-center justify-center z-[-1]"
        >
          <h1
            class="w-full text-newGrey md:text-9xl text-7xl scale-125 font-belgiano font-black text-center md:scale-[2.5] opacity-5"
          >
            CASPIAN
          </h1>
        </div>
        <div
          class="md:w-full w-[95%] mx-auto flex items-center justify-center mt-20 switchCont"
        >
          <img
            :src="spectrum[activeSpectrum].car"
            class="w-full mx-auto md:w-1/2"
            alt=""
          />
        </div>
      </section>
      <section class="w-[95%] max-w-[1550px] mx-auto md:pb-[120px] pb-9">
        <div class="w-[80%] mx-auto max-w-xl mt-9">
          <div class="flex items-center justify-center w-full">
            <div>
              <p class="text-sm text-newGrey opacity-65">Available colors</p>
              <div class="flex items-center w-full gap-3 mt-1">
                <img
                  class="w-10 h-10 overflow-hidden rounded-full cursor-pointer"
                  :class="[
                    activeSpectrum === index ? 'border-[3px] border-green' : '',
                  ]"
                  v-for="(col, index) in spectrum"
                  :key="index"
                  :src="col.icon"
                  @click="changeCarTo(index)"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </section> -->
      <section class="w-full">
        <div class="w-[95%] max-w-[1550px] mx-auto py-[60px]">
          <div class="md:w-[80%] w-full mx-auto max-w-xl">
            <div class="w-full">
              <div class="w-full">
                <h6 class="text-lg font-belgiano md:text-2xl mb-2">Specs</h6>
                <div
                  class="flex md:grid md:grid-cols-3 items-start flex-wrap w-full justify-between gap-y-4 md:gap-8"
                >
                  <div
                    v-for="spec in showAll ? specs : specs.slice(0, 6)"
                    :key="spec.title"
                    class="w-fit md:min-w-fit min-w-[50%] px-2 py-1 md:px-5 md:py-4"
                  >
                    <p class="w-full text-sm whitespace-nowrap">
                      {{ spec.title }}
                    </p>
                    <p class="w-full whitespace-nowrap">
                      <!-- <br /> -->
                      {{ spec.value }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="w-full" v-if="showAll">
                <div
                  class="w-full mt-8"
                  v-for="other in otherSpecs"
                  :key="other.title"
                >
                  <h6 class="text-lg font-belgiano md:text-2xl mb-2">
                    {{ other.title }}
                  </h6>
                  <div
                    class="flex flex-wrap items-start w-full gap-4 pl-2 mt-2 md:px-7 md:pl-0 md:gap-8"
                  >
                    <div
                      class="vehSpec"
                      v-for="otherValue in other.values"
                      :key="otherValue"
                    >
                      <span class="bigDot"></span>
                      <p>{{ otherValue }}</p>
                    </div>
                  </div>
                </div>
                <div class="w-full">
                  <div class="px-2 py-4 mt-3">
                    <p class="text-lg">
                      <span class="text-sm">Warranty</span>
                      <br />
                      36 months
                    </p>
                  </div>
                  <div class="w-full mt-3">
                    <div
                      class="inline-block py-2 pl-3 pr-4 bg-green bg-opacity-10"
                    >
                      <p class="font-inter leading-[26px] text-green">
                        Home charging available
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="w-full">
                <button
                  v-if="!showAll"
                  @click="showAll = true"
                  class="black-btn long mt-7"
                >
                  See More
                </button>
                <div class="flex items-center justify-between w-full" v-else>
                  <router-link :to="{ name: 'order-caspian' }">
                    <button class="black-btn long mt-7">Order Now</button>
                  </router-link>
                  <button
                    class="white-btn long mt-7 black-border"
                    @click="showAll = false"
                  >
                    See Less
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import gsap from "gsap";
import col1 from "@/assets/images/caspian/colors/gray.png";
import col2 from "@/assets/images/caspian/colors/blue.png";
import col3 from "@/assets/images/caspian/colors/cyan.png";
import col4 from "@/assets/images/caspian/colors/white.png";
import car1 from "@/assets/images/caspian/colors/Midnight_Gray_Spectrum.png";
import car2 from "@/assets/images/caspian/colors/Sky_Blue.png";
import car3 from "@/assets/images/caspian/colors/Glaze_Cyan.png";
import car4 from "@/assets/images/caspian/colors/Storm_White.png";
export default {
  data() {
    return {
      lhero: false,
      showAll: false,
      swipe: {
        touchstartX: 0,
        touchendX: 0,
      },
      specs: [
        { title: "Level", value: "Compact SUV" },
        { title: "Electric motor", value: "166 horsepower" },
        { title: "Pure electric range (km)", value: "445" },
        { title: "Charging time (DC)", value: "0.38" },
        { title: "Charging time (AC)", value: "3.6" },
        { title: "Fast charging capacity (%)", value: "30-80" },
        { title: "Max power (kW)", value: "122 (166Ps)" },
        { title: "Max torque (N.m)", value: "200" },
        {
          title: "Gearbox",
          value: "Electric vehicle single speed transmission",
        },
        { title: "L x W x H", value: "4450 x 1860 x 1635" },
        { title: "Body Structure", value: "5-door, 5-seater SUV" },
        { title: "Max speed (km/h)", value: "160" },
        { title: "Official 0-50km/h acceleration time (s)", value: "3.3" },
        { title: "Power consumption per 100km", value: "11.8" },
        {
          title: "Electric energy equivalent fuel consumption (L/100km)",
          value: "1.37",
        },

        { title: "Wheelbase (mm)", value: "2750" },
        { title: "Front wheelbase (mm)", value: "1595" },
        { title: "Rear track (mm)", value: "1575" },
        { title: "Door opening method", value: "Swing door" },
        { title: "Curb mass (kg)", value: "1905" },
        { title: "Luggage compartment volume (L)", value: "415-1601" },
        { title: "Min turning radius", value: "5.45m" },
        { title: "Drag coefficient (Cd)", value: "0.248" },
        { title: "Motor type", value: "Permanent magnet/synchronous" },
        { title: "Battery type", value: "Lithium iron phosphate battery" },
        { title: "Battery capacity (kWh)", value: "48.35" },
        { title: "Battery charging (fast)", value: "0.38" },
        { title: "Battery charging (slow)", value: "3.6" },
        {
          title: "Battery Management System",
          value: "Low temperature and liquid cooling",
        },
        { title: "V2L max external discharge power", value: "3.3kW" },
        { title: "Number of gears", value: "1" },
        {
          title: "Front tire specifications and dimensions",
          value: "215/60 R17",
        },
        {
          title: "Rear tire specifications and dimensions",
          value: "215/60 R17",
        },
        { title: "Rear seat folding ratio", value: "40:60" },
      ],
      otherSpecs: [
        {
          title: "Powertrain",
          values: [
            "Lithium Iron Sulfate Battery",
            "V2L",
            "12V Battery Auto Charging",
          ],
        },
        {
          title: "Chassis System",
          values: [
            "Front floating caliper",
            "Rear floating caliper",
            "Electronic Power Steering (EPS)",
            "Electronic braking system",
            "AUTOHOLD",
            "One-pedal",
          ],
        },
        {
          title: "Exterior",
          values: [
            "Interior central locking",
            "Remote Control Smart Key (RF)",
            "Keyless entry",
            "Keyless start",
            "Eletric adjustable exterior rearview mirror",
            " Heated exterior mirrors",
            "Manual anti-glare interior mirrors",
            "Defrost the rear windshield",
            "Forecabin Decorative cover",
          ],
        },
        {
          title: "Light",
          values: [
            "LED front combination light",
            "Integrated LED rear taillights throughout",
            "Daytime running lights",
            "Automatic Headlights",
            "Rear fog lights",
            "Charging port indicator",
            "Headlight automatic delay function",
            "LED reading lights Front reading light touch controls",
            "Luggage compartment lights",
            "Door and window keys backlight",
          ],
        },
        {
          title: "Interior",
          values: [
            "Leather steering wheel",
            "Multifunctional steering wheel",
            "Front Row 12V power",
            "USB (Front row)",
            "USB (2nd row)",
            "Wireless power charging",
            "Power windows",
            "Front  Sun Visor with Vanity Mirror",
          ],
        },
        {
          title: "Seat",
          values: [
            "PVC Leather Seats",
            "Driver Seat Adjustment",
            "Passenger Seat Adjustment",
            "Heated Front Seats",
            "Second Row Seat Backrest Folding",
          ],
        },
        {
          title: "Air Conditioning",
          values: ["Automatic Air Conditioning"],
        },
        {
          title: "Safety",
          values: [
            "Antilock Brake System+Electronic Brake force Distribution(ABS+EBD)",
            "Braking Assist (EBA/BAS/BA, etc.)",
            "Body Stability Control (ESC/ESP, etc.)",
            "Traction Control (ASR/TCS/TRC, etc.)",
            "Hill hold control (HHC)",
            "Hill descent control (HDC)",
            "Airbags (Front)",
            " ITPMS",
            "Driver Seat Belt Un-Fastened Reminder",
            "Co-driver Seat Belt Un-Fastened Reminder",
            "Second Row Seat Belt Unbuckled Alert",
            "Second Row Seat  Status Monitoring",
            "Second Row Child Seat Interface (ISOFIX/LATCH compatible)",
            "Mechanical Children Safety Lock",
            "Speed Sensitive Control Locking",
            "Automatic Collision Unlock",
            "Rear Parking Radar",
            "Reverse camera with dynamic auxiliary line",
          ],
        },
        {
          title: "Advanced Driving Assistance System",
          values: [
            "Cruise Control (CC)",
            "Segment Code Instrument Panel",
            "Low-speed Pedestrian Beep",
            "Local FM Radio",
            "CarPlay/AndroidAuto",
            "Bluetooth Music/Phone",
          ],
        },
      ],
      spectrum: [
        {
          icon: col1,
          car: car1,
        },
        {
          icon: col2,
          car: car2,
        },
        {
          icon: col3,
          car: car3,
        },
        {
          icon: col4,
          car: car4,
        },
      ],
      activeSpectrum: 0,
    };
  },
  computed: {
    downpaymentPercentage() {
      return this.$store.getters.downPayment;
    },
    mobile() {
      return window.innerWidth <= 768;
    },
    prcs() {
      return this.$store.getters.dispPrices;
    },
  },
  methods: {
    handleSwipe() {
      if (this.swipe.touchendX < this.swipe.touchstartX) {
        if (this.activeSpectrum < this.spectrum.length - 1) {
          this.changeCarTo(this.activeSpectrum + 1);
        }
      }
      if (this.swipe.touchendX > this.swipe.touchstartX) {
        if (this.activeSpectrum > 0) {
          this.changeCarTo(this.activeSpectrum - 1, true);
        }
      }
    },
    async changeCarTo(index, reverse = false) {
      const changeTo = async (index) => {
        this.activeSpectrum = index;
      };
      if (reverse) {
        if (this.activeSpectrum !== 0) {
          gsap.to(".switchCont", {
            xPercent: 110,
            duration: 0.4,
            ease: "Power4.in",
            async onComplete() {
              await changeTo(index);
              gsap.set(".switchCont", {
                xPercent: -110,
                onComplete() {
                  gsap.to(".switchCont", {
                    xPercent: 0,
                    duration: 0.6,
                    ease: "Power4.out",
                  });
                },
              });
            },
          });
        }
      } else {
        if (this.activeSpectrum !== index) {
          gsap.to(".switchCont", {
            xPercent: -110,
            duration: 0.4,
            ease: "Power4.in",
            async onComplete() {
              await changeTo(index);
              gsap.set(".switchCont", {
                xPercent: 110,
                onComplete() {
                  gsap.to(".switchCont", {
                    xPercent: 0,
                    duration: 0.6,
                    ease: "Power4.out",
                  });
                },
              });
            },
          });
        }
      }
    },
  },
  watch: {
    lhero() {
      if (this.lhero === true) {
        this.$refs.swipeArea.addEventListener("touchstart", (e) => {
          this.swipe.touchstartX = e.changedTouches[0].screenX;
        });
        this.$refs.swipeArea.addEventListener("touchend", (e) => {
          this.swipe.touchendX = e.changedTouches[0].screenX;
          this.handleSwipe();
        });
      }
    },
  },
};
</script>

<style scoped >
.heroBG {
  background-image: url("@/assets/images/caspian/hero.jpg");
  background-position: top right;
  background-size: cover;
}
.ovl {
  background: linear-gradient(0deg, #000000 0%, rgba(0, 0, 0, 0) 100%);
}
@media (max-width: 768px) {
  .heroBG {
    background-position: 13% bottom;
    background-image: url("@/assets/images/caspian/hero.jpg");
  }
}
.specBack {
  background-image: url("@/assets/svgs/greyLogo.svg");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
}

.vehSpec {
  @apply flex items-center gap-3 md:w-auto w-full;
}
.bigDot {
  @apply inline-block w-2 h-2 rounded-full bg-green bg-opacity-65;
}
</style>
